import React, { FunctionComponent } from "react";
import styled, { ThemeProvider } from "styled-components";
import { defaultTheme } from "../../theme";
import { graphql, Link, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import { RichText } from "prismic-reactjs";
import linkResolver from "../utils/linkResolver";


const Wrapper = styled.div`
  max-width: 350px;
  margin-top: 50px;
`;

const ImageWrapper = styled.div`
  height: fit-content;
  overflow: hidden;
  border-radius: ${props => props.theme.defaultBorderRadius};
  width: 150px;
  max-width: 150px;
  min-width: 150px;
`;

const MiniPostWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;

  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: translateY(-3px);
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 20px;
`;

const DateText = styled.span`
  color: ${props => props.theme.colors.base};
`;

const TitleText = styled.h4`
  margin-bottom: 0;
`;


export const ArticleWidgetFragment = graphql` fragment ArticleWidgetFragment on PRISMIC_Article {
    title
    _meta {
        firstPublicationDate
        type
        uid
    }
    description
    image
    imageSharp {
        childImageSharp {
            fluid(srcSetBreakpoints: [480]) {
                sizes
                src
                srcSet
                base64
                presentationHeight
                presentationWidth
                aspectRatio
            }
        }
    }
} `;


const FeaturedPosts: FunctionComponent = () => {

    const data = useStaticQuery<GatsbyTypes.FeaturedPostsQuery>(graphql`
        query FeaturedPosts {
            prismic {
                allFeatureds {
                    edges {
                        node {
                            title
                            post1 {
                                ... on PRISMIC_Article {
                                    ...ArticleWidgetFragment
                                }
                            }
                            post2 {
                                ... on PRISMIC_Article {
                                    ...ArticleWidgetFragment
                                }
                            }
                            post3 {
                                ... on PRISMIC_Article {
                                    ...ArticleWidgetFragment
                                }
                            }
                            post4 {
                                ... on PRISMIC_Article {
                                    ...ArticleWidgetFragment
                                }
                            }
                            post5 {
                                ... on PRISMIC_Article {
                                    ...ArticleWidgetFragment
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    let title;
    let post1;
    let post2;
    let post3;
    let post4;
    let post5;


    if (data?.prismic?.allFeatureds?.edges && data?.prismic?.allFeatureds?.edges[0]) {
        title = data.prismic.allFeatureds.edges[0].node.title;
        post1 = data.prismic.allFeatureds.edges[0].node.post1 as unknown as GatsbyTypes.PRISMIC_Article;
        post2 = data.prismic.allFeatureds.edges[0].node.post2 as unknown as GatsbyTypes.PRISMIC_Article;
        post3 = data.prismic.allFeatureds.edges[0].node.post3 as unknown as GatsbyTypes.PRISMIC_Article;
        post4 = data.prismic.allFeatureds.edges[0].node.post4 as unknown as GatsbyTypes.PRISMIC_Article;
        post5 = data.prismic.allFeatureds.edges[0].node.post5 as unknown as GatsbyTypes.PRISMIC_Article;
    }

    return (
        <ThemeProvider theme={defaultTheme}>
            <Wrapper>
                <h3>{RichText.asText(title)}</h3>
                {
                    post1 &&
                    <Link to={linkResolver(post1._meta)} key={post1._meta.uid}>
                        <MiniPostWrapper>
                            <ImageWrapper>
                                {!!post1?.imageSharp?.childImageSharp?.fluid &&
                                <Img fluid={post1?.imageSharp?.childImageSharp?.fluid} />}
                            </ImageWrapper>
                            <ContentWrapper>
                                <TitleText>{RichText.asText(post1.title)}</TitleText>
                                <DateText>
                                    {new Date(post1._meta.firstPublicationDate).toLocaleDateString("pl-PL", {
                                        day: "numeric",
                                        month: "numeric",
                                        year: "numeric"
                                    })}
                                </DateText>
                            </ContentWrapper>
                        </MiniPostWrapper>
                    </Link>
                }
                {
                    post2 &&
                    <Link to={linkResolver(post2._meta)}  key={post2._meta.uid}>
                        <MiniPostWrapper>
                            <ImageWrapper>
                                {!!post2?.imageSharp?.childImageSharp?.fluid &&
                                <Img fluid={post2?.imageSharp?.childImageSharp?.fluid} />}
                            </ImageWrapper>
                            <ContentWrapper>
                                <TitleText>{RichText.asText(post2.title)}</TitleText>
                                <DateText>
                                    {new Date(post2._meta.firstPublicationDate).toLocaleDateString("pl-PL", {
                                        day: "numeric",
                                        month: "numeric",
                                        year: "numeric"
                                    })}
                                </DateText>
                            </ContentWrapper>
                        </MiniPostWrapper>
                    </Link>
                }


            </Wrapper>
        </ThemeProvider>
    );
};

export default FeaturedPosts;